class CookieConsentBanner extends HTMLElement {
  connectedCallback() {
    this.manageButton = this.querySelector('[data-cookie-consent-manage]');
    this.rejectButton = this.querySelector('[data-cookie-consent-reject]');
    this.acceptButton = this.querySelector('[data-cookie-consent-accept]');
    this.saveButton = this.querySelector('[data-cookie-consent-save]');
    this.preferencesPanel = this.querySelector('[data-cookie-consent-preferences]');
    this.analyticsCheckbox = this.querySelector('[data-consent-analytics]');
    this.marketingCheckbox = this.querySelector('[data-consent-marketing]');

    this.manageButton?.addEventListener('click', () => this.showPreferences());
    this.rejectButton?.addEventListener('click', () => this.setConsent(false, false));
    this.acceptButton?.addEventListener('click', () => this.setConsent(true, true));
    this.saveButton?.addEventListener('click', () => {
      this.setConsent(Boolean(this.analyticsCheckbox?.checked), Boolean(this.marketingCheckbox?.checked));
    });

    this.waitForPrivacyApi(0);
  }

  waitForPrivacyApi(attempt) {
    const api = window.Shopify?.customerPrivacy;

    if (api) {
      if (api.shouldShowBanner()) this.show();
      return;
    }

    if (attempt > 20) return;
    setTimeout(() => this.waitForPrivacyApi(attempt + 1), 150);
  }

  show() {
    this.removeAttribute('hidden');
    this.classList.add('is-visible');
  }

  hide() {
    this.setAttribute('hidden', '');
    this.classList.remove('is-visible');
  }

  showPreferences() {
    this.preferencesPanel?.removeAttribute('hidden');
    this.manageButton?.setAttribute('hidden', '');
    this.rejectButton?.setAttribute('hidden', '');
    this.acceptButton?.setAttribute('hidden', '');
    this.saveButton?.removeAttribute('hidden');
  }

  setConsent(analytics, marketing) {
    window.Shopify.customerPrivacy.setTrackingConsent(
      {
        analytics,
        marketing,
        preferences: analytics,
        sale_of_data: marketing,
      },
      () => this.hide()
    );
  }
}

customElements.define('cookie-consent-banner', CookieConsentBanner);
